// TabsObjetivos.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Box, Tabs, Tab, IconButton, Grid } from "@mui/material";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import GetObjetivosAprendizaje from "../ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useProyecto } from "../../data/ProyectoContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}


export default function TabsObjetivos({
  nombreNivel,
  asignaturaSeleccionada,
  setPromptData,
  objetivosSeleccionados,
  setObjetivosSeleccionados,
  setIsOAAdded,
}) {
  const { proyecto, setProyecto } = useProyecto();

  // Fuente de verdad
  const materiasCN = useMemo(
    () => (Array.isArray(proyecto?.materias_cn) ? proyecto.materias_cn : []),
    [proyecto?.materias_cn]
  );

  // Tabs derivadas 
  const tabs = useMemo(
    () => materiasCN.map((m) => ({ nombreAsignatura: m })),
    [materiasCN]
  );


  const [value, setValue] = useState(0);

  
  useEffect(() => {
    if (value > tabs.length - 1) {
      setValue(tabs.length > 0 ? tabs.length - 1 : 0);
    }
  }, [tabs.length, value]);


  useEffect(() => {
    const nombre = asignaturaSeleccionada?.nombre;
    if (!nombre) return;

    setProyecto((prev) => {
      const prevArr = Array.isArray(prev?.materias_cn) ? prev.materias_cn : [];
      const exists = prevArr.includes(nombre);

      const nextArr = exists ? prevArr : [...prevArr, nombre];

      // Actualiza promptData
      if (typeof setPromptData === "function") {
        setPromptData((p) => {
          const pArr = Array.isArray(p?.materias_cn) ? p.materias_cn : [];
          const pExists = pArr.includes(nombre);
          return { ...p, materias_cn: pExists ? pArr : [...pArr, nombre] };
        });
      }

      // Selecciona el tab correcto
      const nextIndex = exists ? prevArr.indexOf(nombre) : nextArr.length - 1;
      setValue(nextIndex);

      return { ...prev, materias_cn: nextArr };
    });
  }, [asignaturaSeleccionada, setProyecto, setPromptData]);

  const handleTabChange = (_event, newValue) => {
    setValue(newValue);
  };

  const handleTabDelete = (deleteIndex) => {
    const tabToDelete = tabs[deleteIndex];
    if (!tabToDelete) return;

    const materia = tabToDelete.nombreAsignatura;

  
    if (objetivosSeleccionados && Array.isArray(objetivosSeleccionados)) {
      const updatedObjetivos = objetivosSeleccionados.filter(
        (item) => item.nombreAsignatura !== materia
      );
      setObjetivosSeleccionados(updatedObjetivos);
    }

  
    setProyecto((prev) => {
      const prevMaterias = Array.isArray(prev?.materias_cn) ? prev.materias_cn : [];
      const nextMaterias = prevMaterias.filter((m) => m !== materia);

      const prevOA = Array.isArray(prev?.objetivos_aprendizaje) ? prev.objetivos_aprendizaje : [];
      const nextOA = prevOA.filter((item) => item.materia !== materia);

      return {
        ...prev,
        materias_cn: nextMaterias,
        objetivos_aprendizaje: nextOA,
      };
    });

    
    if (typeof setPromptData === "function") {
      setPromptData((p) => {
        const pArr = Array.isArray(p?.materias_cn) ? p.materias_cn : [];
        return { ...p, materias_cn: pArr.filter((m) => m !== materia) };
      });
    }

   
    setValue((prevValue) => {
      if (prevValue === deleteIndex) {
        return tabs.length - 1 > 0 ? (deleteIndex === 0 ? 0 : deleteIndex - 1) : 0;
      }
      if (prevValue > deleteIndex) return prevValue - 1;
      return prevValue;
    });
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Objetivos por asignatura"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#336B87",
            height: 3,
            width: "70%",
            borderRadius: 2,
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.nombreAsignatura} 
            label={
              <Grid
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  backgroundColor: "rgba(250, 219, 151, 1)",
                  color: "#336B87",
                  fontFamily: "Montserrat",
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  pl: 3,
                  pr: 3,
                  pt: 2,
                  pb: 2,
                  borderRadius: "10px",
                }}
              >
                {tab.nombreAsignatura}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTabDelete(index);
                  }}
                  sx={{ ml: 1, color: "#336B87" }}
                >
                  <DeleteForeverRoundedIcon />
                </IconButton>
              </Grid>
            }
            id={`tab-${index}`}
            aria-controls={`tab-panel-${index}`}
          />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <TabPanel key={tab.nombreAsignatura} value={value} index={index}>
          <GetObjetivosAprendizaje
            nombreAsignatura={tab.nombreAsignatura}
            nombreNivel={nombreNivel}
            setPromptData={setPromptData}
            objetivosSeleccionados={objetivosSeleccionados}
            setObjetivosSeleccionados={setObjetivosSeleccionados}
            setIsOAAdded={setIsOAAdded}
          />
        </TabPanel>
      ))}
    </Box>
  );
}
